import {Base64Converter} from './Base64Converter';
import './DataFormat.css';
export const Base64 = () => {
	return (
		<>
			<Base64Converter></Base64Converter>
		</>
	);
};
